// Products temporarily taken off the site. Their data and images stay in
// products.json and public/images; remove a name from this list (or comment
// it out) to show that product again everywhere.
export const HIDDEN_PRODUCTS: string[] = [
  "PF-20", // blast freezer
  "Eutectic Plate",
];

export const isVisibleProduct = (product: { name: string }) => !HIDDEN_PRODUCTS.includes(product.name);
